<template>
  <div id="app" class="new-background">
    <router-view/>
  </div>
</template>

<script>

  export default {
    name: 'App',
    data () {
      return {}
    },
    mounted () {
      // this.$store.dispatch('setUser')
    }
  }
</script>

<style lang="scss">
  @import "toastr/build/toastr.min.css";

  .header-transparent {
    header {
      background-color: transparent;
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 1000;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }
  }

  .new-background {
    background: url('/static/background_new.png') center 0 no-repeat;
    background-size: 100%;
  }

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

  .clearfix {
    display: inline-block;
  }

  /* start commented backslash hack \*/
  * html .clearfix {
    height: 1%;
  }

  .clearfix {
    display: block;
  }

  /* close commented backslash hack */

  body {
    margin: 0;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    height: 100vh;
  }

  a, button, svg {
    font-family: 'Roboto', sans-serif;
    font-weight: normal;
    appearance: none;
    /*box-shadow: none;*/
    border: none;
    text-decoration: none;
    color: #000;
    &:focus, &:hover, &:active {
      outline: none;
      border: none;
      box-shadow: none;
      color: #000;
    }
  }

  #app {
    // min-height: 100%;
    // height: 100%;
    background-attachment: fixed;
    position: relative;
  }

  .container {
    margin: 0 auto;
    width: 1140px;
    /*min-width: 1140px;*/
    padding: 0 15px;
    max-width: 100%;
    box-sizing: border-box;
  }

  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h1, h2, h3, h4, h5 {
    font-weight: normal;
  }

  .text-center {
    text-align: center !important;
  }

  .text-right {
    text-align: right !important;
  }

  .content {
    padding-top: 15px;
    padding-bottom: 15px;
    min-height: calc(100vh - 272px);
    position: relative;
    font-size: 16px;
    @media screen and (max-width: 500px) {
      font-size: 11px;
    }
    h1.center {
      text-align: center;
      font-size: 1.5em;
      margin: 40px 0 50px 0;
    }
    .back {
      color: #b3b3b3;
      cursor: pointer;
      span, svg {
        display: inline-block;
        vertical-align: middle;
      }
      path {
        fill: #b3b3b3;
        margin-right: 5px;
      }
      &:hover {
        color: $blue;
        path {
          fill: $blue;
        }
      }
    }
  }

  .btn {
    display: inline-block;
    padding: 12px 35px;
    cursor: pointer;
    background-color: $btn-blue;
    border-radius: 3px;
    font-weight: 300;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: box-shadow 0.3s cubic-bezier(.25, .8, .25, 1);
    box-sizing: border-box;
    font-size: 16px;
    &:hover {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }
    &-lg {
      width: 485px;
      max-width: 100%;
      padding: 28px;
      font-size: 1.2em;
    }
    &-light {
      background-color: #fff;
      border-top: 1px solid $light-blue;
    }
    &-more {
      display: inline-block;
      margin-left: 10px;
      background-color: #fff;
      border: 1px solid $light-blue;
      padding: 0 6px;
      font-size: 13px;
      cursor: pointer;
      border-radius: 5px;
      min-width: 15px;
      text-align: center;
      &:hover {
        border: 1px solid $blue;
      }
    }
    svg {
      margin-right: 10px;
      path {
        fill: #B3CEE0;
      }
    }
  }

  .buttons-group-right {
    position: absolute;
    right: 0;
    bottom: 0;
    text-align: right;
    padding-left: 15px;
    padding-right: 15px;
    .btn {
      margin-left: 20px;
      margin-bottom: 20px;
    }
  }

  .relative {
    position: relative;
    min-height: 300px;
  }

  .checkbox {
    position: absolute; // take it out of document flow
    opacity: 0; // hide it

    & + label {
      position: relative;
      cursor: pointer;
      padding: 0;
    }

    // Box.
    & + label:before {
      content: '';
      margin-right: 10px;
      display: inline-block;
      vertical-align: text-top;
      width: 20px;
      height: 20px;
      background: white;
      border: 1px solid $light-blue;
      transition: all .2s ease;
    }

    // Box hover
    &:hover + label:before {
      border-color: $blue;
    }

    // Box checked
    &:checked + label:before {
      background: $blue;
    }

    // Disabled state label.
    &:disabled + label {
      color: #b8b8b8;
      cursor: auto;
    }

    // Disabled box.
    &:disabled + label:before {
      box-shadow: none;
      background: #ddd;
    }

    // Checkmark. Could be replaced with an image
    &:checked + label:after {
      content: '';
      position: absolute;
      left: 5px;
      top: 9px;
      background: white;
      width: 2px;
      height: 2px;
      box-shadow: 2px 0 0 white,
      4px 0 0 white,
      4px -2px 0 white,
      4px -4px 0 white,
      4px -6px 0 white,
      4px -8px 0 white;
      transform: rotate(45deg);
    }
  }

  .vue-tooltip.tooltip-custom {
    background-color: #fff;
    color: #000;
    box-shadow: none;
    max-width: 110px;
    width: auto;
    font-size: 11px;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    text-align: center;
  }

  .vue-tooltip.tooltip-custom .tooltip-arrow {
    border: none;
  }

  .hint {
    background-color: $light-blue;
    width: 513px;
    box-sizing: border-box;
    text-align: center;
    padding: 14px;
    font-weight: 300;
    border-radius: 6px;
    span {
      margin-left: 10px;
    }
  }

  /*transitions*/
  /*fade*/
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  /**/
  .slidefade-enter-active {
    transition: all ease .2s;
  }

  .slidefade-leave-active {
    transition: all ease 0s;
  }

  .slidefade-enter {
    transform: translate(20px);
    opacity: 0;
  }

  /**/
  .slide-enter-active, .slide-leave-active {
    transition: all ease .4s;
  }

  .slide-enter, .slide-leave-to {
    transform: translateY(30px);
    opacity: 0;
  }

  /*bounce*/
  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  input, select, textarea {
    border: 1px solid $light-blue;
    font-size: 16px;
    border-radius: 3px;
    padding: 14px;
    transition: border 0.2s ease-out;
    box-sizing: border-box;
    max-width: 100%;
    resize: none;
    &:focus {
      outline: none;
      border: 1px solid $blue;
    }
  }

  .form {
    &.form-sm {
      width: 500px;
    }
  }

  .form-group {
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    label {
      display: inline-block;
      width: 110px;
      font-weight: 300;
    }
    input, select, textarea, .v-select {
      flex: 1;
    }
    .error {
      margin-left: 113px;
      margin-top: 5px;
      margin-bottom: 20px;
      font-size: 14px;
      width: 100%;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
    .modal-window {
      position: absolute;
      top: 50%;
      left: 50%;
      transition: .5s;
      box-sizing: border-box;
      width: 790px;
      max-width: 100%;
      background: white;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
      padding: 40px;
      color: black;
      text-align: center;
      transform: translate(-50%, -50%);
      border-radius: 7px;
      .top-line {
        position: relative;
        min-height: 20px;
        margin-bottom: 40px;
        .close {
          position: absolute;
          right: 0;
          fill: #ccc;
          cursor: pointer;
          transition: all .2s;
          &:hover {
            fill: $blue;
          }
        }
      }
    }
  }

  table.main-table {
    width: calc(100% + 70px);
    text-align: left;
    margin-left: -35px;
    margin-right: -35px;
    font-weight: 300;
    tbody tr:hover {
      background-color: $very-light-blue;
    }
    tr {
      th, td {
        padding: 10px 5px;

        &:first-child {
          padding-left: 35px;
        }
        &:last-child {
          padding-right: 35px;
        }
      }
      th {
        font-weight: 400;
        color: #808080;
        font-size: 13px;
        &.fio {
          width: 50%;
        }
        &.index {
          width: 67px;
        }
      }
      td {
        &.groups {
          span {
            display: block;
            line-height: 22px;
            &:first-child {
              display: inline-block;
            }
            &.more {
              display: inline-block;
              margin-left: 10px;
              background-color: #fff;
              border: 1px solid $light-blue;
              padding: 0 6px;
              font-size: 13px;
              cursor: pointer;
              border-radius: 5px;
              min-width: 15px;
              text-align: center;
              &:hover {
                border-color: $blue;
              }
            }
          }
        }
        &.hover {
          cursor: pointer;
          font-weight: 400;
          &:hover {
            text-decoration: underline;
          }
        }
        &:last-child {
          text-align: right;

          svg {
            margin-left: 20px;
            cursor: pointer;
            &:hover path {
              fill: $blue;
            }
            path {
              fill: #B3CEE0;
            }
          }
        }
      }
    }
  }

  .no-players {
    b {
      font-weight: 400;
    }
    margin-top: 150px;
    text-align: center;
    .text {
      color: #666666;
      font-weight: 300;
      font-size: 1.5em;
      line-height: 2em;
      margin-bottom: 20px;
    }
  }

  .grid {
    .row {
      margin: 0 -12px;
      font-size: 0;
      display: flex;
      flex-wrap: wrap;
      justify-items: stretch;
    }
    .col-3 {
      width: 33.3%;
    }
    .col-2 {
      width: 50%;
    }
    .col-3, .col-2 {
      box-sizing: border-box;
      padding: 0 12px;
      margin: 16px 0;
      .btn {
        display: block;
        height: 100%;
        background-color: #EAF2FA;
        padding: 25px 20px 25px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 18px;
      }
    }
    .col-1-xs {
      @media screen and (max-width: 500px) {
        width: 100%;
      }
    }
  }

  .vs__dropdown-toggle {
    border: 1px solid $light-blue !important;
    border-radius: 3px !important;
    transition: border 0.2s ease-out !important;
    box-sizing: border-box !important;
    max-width: 100% !important;
    resize: none !important;
    padding: 7px !important;
    background: #fff !important;
    &:focus {
      outline: none !important;
      border: 1px solid $blue !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue